module.exports = __webpack_public_path__ + "img/10.c260b0db.jpg";